// Delas mellan server och webbgränssnitt.

export const MUNICIPALITIES = [
  'Arjeplog',
  'Arvidsjaur',
  'Boden',
  'Gällivare',
  'Haparanda',
  'Jokkmokk',
  'Kalix',
  'Kiruna',
  'Luleå',
  'Pajala',
  'Piteå',
  'Älvsbyn',
  'Överkalix',
  'Övertorneå',
  'Annan kommun',
] as const;

export const SCHOOL_FORMS = [
  'Förskola',
  'Förskoleklass',
  'Fritidshem',
  'Grundskola åk 1–3',
  'Grundskola åk 4–6',
  'Grundskola åk 7–9',
  'Anpassad grundskola',
  'Gymnasieskola',
  'Anpassad gymnasieskola',
  'Vuxenutbildning',
  'Annan verksamhet',
] as const;

export const ITEM_KIND_LABELS: Record<string, string> = {
  page: 'Text',
  video: 'Film',
  audio: 'Ljud',
  quiz: 'Quiz',
  discussion: 'Diskussion',
  assignment: 'Uppgift',
  meeting: 'Träff',
  link: 'Länk',
  deepdive: 'Fördjupning',
  tryout: 'Prova i klassrummet',
  reflection: 'Reflektion',
};

export const PASSWORD_MIN_LENGTH = 10;

/** Ämnen i kontaktformuläret. */
export const CONTACT_TOPICS = [
  'Kursen och innehållet',
  'Konto och inloggning',
  'Intyg',
  'Kommun, skola och anmälan',
  'Annat',
] as const;
